import { FC } from 'react'

import './style.scss'
import { Text } from '../../UI'

type MedicalAppointmentsSummaryProps = {
  className?: string,
  appointments: any[]
}

const MedicalAppointmentsSummary:FC<MedicalAppointmentsSummaryProps> = ({ className = '', appointments }) => {
  return (
    <div className={className}>
      {appointments && appointments.map((it, i) =>
        <div key={i} className={`row ${i > 0 ? 'mt-20' : ''}`}>
          <div className="col-5">
            <div className="d-flex align-items-center">
              <img src={it.doctor_image} alt="" width="42" height="42" className="medicalappointments-image" />

              <div className="ml-10">
                <Text size="13" weight="semibold" className="xl:fz-14">{it.doctor_name}</Text>
                <Text size="12" color="gray-600">{it.specialty}</Text>
              </div>
            </div>
          </div>
          <div className="col-2 text-center px-0">
            <Text component="label" size="14" color="primary">Fecha</Text>
            <Text size="13" weight="semibold" className="xl:fz-14">{it.date}</Text>
          </div>
          <div className="col-2 text-center pr-0">
            <Text component="label" size="14" color="primary">Hora</Text>
            <Text size="13" weight="semibold" className="xl:fz-14">{it.hour}</Text>
          </div>
          <div className="col-3 text-center px-0">
            <Text component="label" size="14" color="primary">Sucursal</Text>
            <Text size="11" weight="semibold">{it.place_care_indisa} {it.place_care}</Text>
          </div>
        </div>
      )}
    </div>
  )
}

export { MedicalAppointmentsSummary }